export const IP_VO = {
	ip: {
		type: "string"
	}
};